import { ComponentRef, Type, ViewRef } from '@angular/core';

import { Observable } from 'rxjs';

import { LayoutHostDirective } from '../components/layout-host.directive';
import { ControlShared, ControlTranslate } from '../utils';
import { DynamicFormDataConfig } from './designer.types';
import { ControlValidatorModel } from './validator.types';
import { DataEntityProperties } from './data-entity.model';
import { SelectConditionViewModel } from './query-condition';

/**
 *
 * @description æ½è±¡æ§ä»¶
 * @export
 */
export interface AbstractControl<T extends ControlViewModel> {
  /**
   * @description æ§ä»¶ç±»å
   *
   * @memberof AbstractControl
   */
  type: string;
  /**
   * @description æ¯å¦æ¯è®¾è®¡æ¶
   *
   * @memberof AbstractControl
   */
  isDesign: boolean;
  /**
   * @description æ¯å¦æ¯å®¹å¨
   *
   * @memberof AbstractControl
   */
  isContainer: boolean;

  /**
   * @description ä»æ¥ç
   *
   * @memberof AbstractControl
   */
  viewOnly?: boolean;

  /**
   * @description å¯ç¨æ¥çæ¶ç¼è¾
   *
   * @memberof AbstractControl
   */
  enableEditAtView?: boolean;

  /**
   * @description å¯ç¨æ¥çæ¶ç¼è¾çæ§ä»¶åç§°åè¡¨
   *
   * @memberof AbstractControl
   */
  enableEditNameList?: string[];
  /**
   * @description è®¾è®¡æ¶hostæ ·å¼ç±»
   *
   * @memberof AbstractControl
   */
  designHostClass: string;
  /**
   * @description æ§ä»¶model
   *
   * @memberof AbstractControl
   */
  model: T;
  /**
   * å­æ§ä»¶
   *
   * @memberof AbstractControl
   */
  children: AbstractControl<ControlViewModel>[];
  /**
   * ç¶èç¹
   */
  parent: AbstractControl<ControlViewModel>;
  /**
   * @description æ¯å¦ææï¼å½æ§ä»¶éªè¯å¨é½éªè¯éè¿ è¿åtrue
   *
   * @memberof AbstractControl
   */
  valid: boolean;

  /**
   * æ°æ®éç½®ä¿¡æ¯
   *
   * TODO @deprecated è¯·ä½¿ç¨æ§ä»¶æ¬èº«çæ°æ®ï¼ç´æ¥æ¾å¨controlæ§ä»¶æ¬èº«ä¸
   * @memberof AbstractControl
   */
  dataConfig: DynamicFormDataConfig;

  /**
   * æ§ä»¶å±äº«äºä»¶
   *
   */
  controlShared: ControlShared;

  /**
   * æ¯å¦éè
   */
  hidden: boolean;

  propertyValueChanged$: Observable<{ name: string; value: any }>;

  /**
   * @description è·åæ§ä»¶DataModel
   *
   * @memberof AbstractControl
   */
  getDataModel(): ControlDataModel;
  /**
   * @description è®¾ç½®æ§ä»¶çå¼
   *
   * @param any value
   * @memberof AbstractControl
   */
  setModelValue(value: any): void;
  /**
   * @description è·åmodelçvalue
   *
   * @returns modelå¼
   * @memberof AbstractControl
   */
  getModelValue(): any;
  /**
   * @description ç»å®äºä»¶
   *
   * @memberof AbstractControl
   */
  bindEvents(): void;
  /**
   * @description éªè¯éªè¯å¨
   *
   * @memberof AbstractControl
   */
  validate(): void;

  propertyValueChanged(name: string, value: any): void;
}

/**
 * å¸å±æ§ä»¶
 *
 */
export interface ControlLayoutHost {
  layoutHost: LayoutHostDirective;
}

/**
 * å¨ææ§ä»¶å®¹å¨
 *
 */
export interface DynamicControlContainer extends ControlLayoutHost {
  controlTranslate: ControlTranslate;
  addControl?(control: ControlLayoutModel): Observable<AbstractControl<any>>;
  addControls?(controls: Array<ControlLayoutModel>): Observable<AbstractControl<any>[]>;
  moveUpView?(hostView: ViewRef): void;
  moveDownView?(hostView: ViewRef): void;
  removeControl?(index?: number): void;
}

/**
 * å¸å±å®¹å¨æ§ä»¶
 *
 */
export interface LayoutControlContainer extends DynamicControlContainer {
  isContainer: boolean;
  control: AbstractContainer<ControlViewModel>;
}

/**
 * è®¾è®¡å¸å±Hostå®¹å¨
 *
 */
export interface DesignHostContainer extends LayoutControlContainer {
  selected: boolean;
  disableOperateControl: boolean;
  parentHost: DynamicControlContainer;
  componentRef: ComponentRef<any>;

  moveUp(index?: number): void;
  moveDown(index?: number): void;
  getViewIndex(): number;
  remove(): void;
}

/**
 * @description æ½è±¡å®¹å¨
 *
 * @export
 */
export interface AbstractContainer<T extends ControlViewModel> extends AbstractControl<T>, DynamicControlContainer {}

/**
 * @description æ§ä»¶å®ä½å±æ§æ¨¡å
 *
 * @export
 */
export class ControlEntityAttributeDataModel {
  /**
   * @description å³èå®ä½
   *
   * @memberof ControlPublishDataModel
   */
  associatedEntities: string;

  /**
   * @deprecated
   * @description å®ä½å±æ§ 1.3.6ä»¥åï¼æ­¤è½æ´å¥½çè¡¨ç¤ºæ­¤å±æ§åçº§ä¸ºentityAttributes
   */
  entityAttribute: string;
  /**
   * @description å®ä½å±æ§
   *
   * @memberof ControlPublishDataModel
   */
  associatedEntityAttributes?: EntityAttributeDataModel[];
}

/**
 * å±æ§æ°æ®æ¨¡å
 */
export interface EntityAttributeDataModel {
  /**
   * æºå±æ§
   */
  source: string;
  /**
   * å³èå±æ§
   */
  target: string;

  /**
   * å¦ææ¯JSONå­æ®µï¼jsonçkey
   */
  jsonKey?: string;
}

/**
 * æ§ä»¶è§å¾æ¨¡å
 *
 */
export class ControlViewModel extends ControlEntityAttributeDataModel {
  /**
   * éªè¯å¨
   *
   * @memberof ControlViewModel
   */
  validators: { [key: string]: ControlValidatorModel<any> } = {};
  /**
   * å³èå®ä½åç§°
   *
   * @memberof ControlViewModel
   */
  associatedEntities: string;
  /**
   * å³èå®ä½å±æ§
   *
   * @memberof ControlViewModel
   */
  entityAttribute: string;
  /**
   * å±ç¤ºåè®¾ç½®
   *
   * @memberof ControlViewModel
   */
  showCondition?: any;
  /**
   * æ¥è¯¢æ¡ä»¶è®¾ç½®
   *
   * @memberof ControlViewModel
   */
  selectCondition?: SelectConditionViewModel;
  /**
   * éé¡¹å¼è®¾ç½®
   *
   * @memberof ControlViewModel
   */
  option?: any;
  /**
   * åå®½
   *
   * @memberof ControlViewModel
   */
  columnLength?: number;

  /**
   * @description æ é¢åå®¹
   *
   * @memberof ControlViewModel
   */
  caption: string;
  /**
   * id
   *
   * @memberof ControlViewModel
   */
  id: string;
  /**
   * æ ·å¼ç±»
   *
   * @memberof ControlViewModel
   */
  class: string;
  /**
   * æ ·å¼
   *
   * @memberof ControlViewModel
   */
  style: string;

  /**
   * æ¯å¦éèï¼é»è®¤false
   *
   * @memberof ControlViewModel
   */
  isHidden: boolean = false;
  /**
   * åç§°
   *
   */
  name: string;
  /**
   * çº§èä¸çº§åç§°
   *
   */
  cascadeParentName: OptionProperty[];

  /**
   * æ ¹æ®Urlè·åçº§èé²ææ¶é´
   *
   */
  cascadeDataByUrlDebounceDueTime?: number;
  /**
   * å¯ä¸æ è¯
   *
   */
  __identityCode: string;
}

export class ContainerViewModel extends ControlViewModel {}

export class ValueControlViewModel<T = any> extends ControlViewModel {
  /**
   * @description æ¯å¦æ¾ç¤ºæ é¢label
   *
   * @memberof ValueControlViewModel
   */
  showLabel: boolean = true;
  /**
   * @description å¼
   *
   * @memberof ValueControlViewModel
   */
  value: T;
  /**
   * ä½¿ç¨çº§èå¼
   *
   * @memberof ValueControlViewModel
   */
  useCascadeValueOfChild: boolean = false;
  /**
   * çº§èå¼
   */
  cascadeValueOfChild: any;
  /**
   * æ¯å¦åªè¯»
   *
   * @memberof ValueControlViewModel
   */
  readonly: boolean;

  /**
   * éèæ¶æ¯å¦æ¸ç©ºå¼
   *
   */
  clearDataWhenHidden: boolean;
  /**
   * æ¥çæ¶æ¾ç¤ºææ¬åå®¹
   *
   */
  showContentAtView?: boolean;
  /**
   * å¯ç¨æ¥çæ¶ç¼è¾
   *
   */
  enableEditAtView?: boolean;
  /**
   * @description å¯ç¨æ¥çæ¶ç¼è¾çæ§ä»¶åç§°åè¡¨
   *
   * @memberof ValueControlViewModel
   */
  enableEditNameList?: string[];
  /**
   * @description æ§ä»¶id
   *
   * @memberof ValueControlViewModel
   */
  id: string;
  /**
   * æ¯å¦å¹¿æ­äºä»¶
   *
   */
  isBroadCastEvent?: boolean;

  /**
   * æç¤ºä¿¡æ¯
   */
  placeholder?: string;

  /**
   * æ¯å¦é»è®¤è§¦åçº§è
   */
  defaultTriggerCascade: boolean;

  constructor(caption: string) {
    super();
    this.caption = caption;
  }
}

export class LabelViewModel extends ValueControlViewModel {
  text: string;
}

export class TextBoxViewModel extends ValueControlViewModel {
  /**
   * @description æç¤ºä¿¡æ¯
   *
   * @memberof TextBoxViewModel
   */
  placeholder: string = '';
  constructor(caption: string, showLabel: boolean = true) {
    super(caption);
    this.caption = caption;
    this.showLabel = showLabel;
  }
}

/**
 * çº§èç¶ç»ä»¶å¼éç¥å¨
 *
 */
export interface CascadeParentValueNotification {
  /**
   * çº§èä¸çº§å¼æ¹å
   */
  onCascadeParentValueChange?: (values: any[]) => any;
}

/**
 * @description æ§ä»¶DataModel
 *
 * @export
 */
export interface ControlDataModel {
  /**
   * ç±»ååç§°
   *
   * @memberof ControlDataModel
   */
  type: string;

  /**
   * å¼
   *
   * @memberof ControlDataModel
   */
  model: ControlViewModel;
  /**
   * å­æ§ä»¶DataModel
   *
   * @memberof ControlDataModel
   */
  children?: Array<ControlDataModel>;
}

/**
 * @description æ§ä»¶å¸å±model
 *
 * @export
 */
export interface ControlLayoutModel {
  /**
   * @description æ§ä»¶ç±»å
   *
   * @memberof ControlLayoutModel
   */
  component: Type<any>;
  /**
   * @description ç±»ååç§°
   *
   * @memberof ControlLayoutModel
   */
  type: string;
  /**
   * æ§ä»¶model
   *
   * @memberof ControlLayoutModel
   */
  model: ControlViewModel;
  /**
   * @description å­æ§ä»¶
   *
   * @memberof ControlLayoutModel
   */
  children?: Array<ControlLayoutModel>;
}

/**
 * @description æ§ä»¶äºä»¶
 *
 * @export
 */
export interface ControlEvent {
  /**
   * @description åç»åç§°
   *
   * @memberof ControlEvent
   */
  groupName: string;
  /**
   * @description åç§°
   *
   * @memberof ControlEvent
   */
  name: string;
  /**
   * èæ¬ï¼èæ¬æ¯JavaScriptåçèæ¬ï¼æèæ¯jqueryèæ¬
   *
   * @memberof ControlEvent
   */
  script: string;
  /**
   * æè¿°
   *
   * @memberof ControlEvent
   */
  description?: string;
}

/**
 * @description éé¡¹å¼ååï¼æ§ä»¶çæ°æ®æºéé¡¹å¼åçååæ¶è§¦å
 *
 * @export
 */
export interface OptionValueChange {
  /**
   * éé¡¹å¼ååï¼æ§ä»¶çæ°æ®æºéé¡¹å¼åçååæ¶è§¦å
   *
   * @memberof OptionValueChange
   */
  optionValueChange(): void;
}

/**
 * @description æ°æ®æºéé¡¹å±æ§
 *
 * @export
 */
export interface OptionProperty {
  /**
   * @description æ¯å¦éä¸­
   *
   * @memberof OptionProperty
   */
  selected: boolean;
  /**
   * @description æ¾ç¤ºåå®¹
   *
   * @memberof OptionProperty
   */
  text: string;

  /**
   * @description éé¡¹id
   *
   * @memberof OptionProperty
   */
  id: string;
  /**
   * @description éé¡¹å¼
   *
   * @memberof OptionProperty
   */
  value: any;
  /**
   * @description æ°æ®æ¾ç¤ºæå
   *
   * @memberof OptionProperty
   */
  displayMember?: string;
  /**
   * @description æ°æ®å¼æå
   *
   * @memberof OptionProperty
   */
  valueMember?: string;
}

export interface OptionItem {
  /**
   * å­å¨å­æ®µ
   */
  id: string;

  /**
   * æ¾ç¤ºå­æ®µ
   */
  text: string;

  /**
   * åå§æ°æ®
   */
  data?: any;
}

/**
 * çº§èæ§ä»¶ç¶çº§å¼
 */
export interface CascadeParentValue {
  /**
   * æ§ä»¶åç§°
   */
  name: string;

  /**
   * æ§ä»¶å±æ§åç§°
   */
  property: string;

  /**
   * æ§ä»¶å¼
   */
  value: any;

  /**
   * æä½
   */
  operate?: string;
}

/**
 * æ§ä»¶æä½æ¨¡å¼
 *
 */
export enum ControlOperateMode {
  /**
   * åå§
   */
  Initial,

  /**
   * æ·»å 
   */
  Add,

  /**
   * ç¼è¾
   */
  Edit,

  /**
   * åªæ¥ç
   */
  View
}
